// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TaskList_wrapper__Q0cUh","shimmers":"TaskList_shimmers__dQAho"};